import { siteConfig } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="font-heading text-2xl font-black text-primary-400 tracking-tight">
                {siteConfig.name}
              </span>
              <p className="text-sm text-background-400 mt-4 leading-relaxed max-w-xs">
                {siteConfig.name}——你的随身娱乐圈内幕雷达。每日更新全网最热门吃瓜日报，覆盖今日吃瓜、明星八卦、娱乐圈最新内幕、爆猛料热榜，让吃瓜变得更简单、更有趣。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-100 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }}>最新快讯</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}>爆料热榜</a>
                <a href="#comments" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#comments')?.scrollIntoView({ behavior: 'smooth' }); }}>瓜友热评</a>
                <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }}>吃瓜指南</a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                更多合作伙伴正在入驻中，敬请期待。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-100 mb-4">联系我们</h4>
              <div className="flex flex-col gap-2.5">
                <span className="text-sm text-background-400">
                  <i className="ri-mail-line mr-2 text-primary-400"></i>tips@mrichigua.com
                </span>
                <span className="text-sm text-background-400">
                  <i className="ri-wechat-line mr-2 text-primary-400"></i>mrichigua_tips
                </span>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
            </p>
            <p className="text-xs text-background-600">
              本站内容来源于公开信息聚合，仅供参考娱乐，不代表本站立场。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}